import script from "./EmpPayslip.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmpPayslip.vue?vue&type=script&setup=true&lang=ts"

import "./EmpPayslip.vue?vue&type=style&index=0&id=7414cede&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7414cede"]])

export default __exports__